import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';

import type { CarouselItem, ListContext } from 'renderer/utils/analytics';
import { buildEvent, findItem } from 'renderer/utils/analytics';

export const useFavouritesAnalytics = (items: CarouselItem[], listContext?: ListContext) => {
  const { trackEvent } = useAnalytics();

  const trackAdd = (lineNumber: string) => {
    const found = findItem(items, lineNumber);
    if (!found) return;
    trackEvent(buildEvent('add_to_wishlist', found.item, found.index, listContext));
  };

  const trackRemove = (lineNumber: string) => {
    const found = findItem(items, lineNumber);
    if (!found) return;
    trackEvent(buildEvent('remove_from_wishlist', found.item, found.index, listContext));
  };

  return { trackAdd, trackRemove };
};
